module.exports = __webpack_public_path__ + "static/img/minicon2.ca1ec1a9.png";